__turbopack_context__.v({
  "articles": "EncyclopediaArticles-module-scss-module__S7cu7a__articles",
  "filter-form": "EncyclopediaArticles-module-scss-module__S7cu7a__filter-form",
  "filters": "EncyclopediaArticles-module-scss-module__S7cu7a__filters",
  "pagination": "EncyclopediaArticles-module-scss-module__S7cu7a__pagination",
});
